import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  type: 'titleBar',
  titleName: '기본 제목',
  bgColor: '#f7f8fa',
};

const NavBarInfoSlice = createSlice({
  name: 'NavBarInfo',
  initialState,
  reducers: {
    setType(state, action) {
      state.type = action.payload;
    },
    setTitleName(state, action) {
      state.titleName = action.payload;
    },
    setBgColor(state, action) {
      state.bgColor = action.payload;
    },
  },
});

export const NavBarInfoActions = NavBarInfoSlice.actions;
export default NavBarInfoSlice.reducer;
